import { NavLink } from 'react-router-dom';
var Footer = function Footer() {
  return /*#__PURE__*/React.createElement("div", {
    className: "footer",
    id: "footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "footer__nav"
  }, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(NavLink, {
    to: "/"
  }, "Home")))), /*#__PURE__*/React.createElement("div", {
    className: "footer__contact"
  }, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: "footer__contact--dark"
  }, "call us"), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("a", {
    href: "tel:+16313905777"
  }, "631.390.5777"))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: "footer__contact--dark"
  }, "email us"), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("a", {
    href: "mailto:washplant@posillicoinc.com"
  }, "washplant@posillicoinc.com"))))));
};
export default Footer;